import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiPayment, CreatePaymentRequest, QueryPaymentsParams } from '@core/models/api/payment.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentsApiService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiBaseUrl}/payments`;

  getAll(query?: QueryPaymentsParams): Observable<ApiPayment[]> {
    let params = new HttpParams();
    if (query?.status) {
      params = params.set('status', query.status);
    }
    return this.http.get<ApiPayment[]>(this.baseUrl, { params });
  }

  getById(id: string): Observable<ApiPayment> {
    return this.http.get<ApiPayment>(`${this.baseUrl}/${id}`);
  }

  create(payload: CreatePaymentRequest): Observable<ApiPayment> {
    return this.http.post<ApiPayment>(this.baseUrl, payload);
  }

  toggleStatus(id: string): Observable<ApiPayment> {
    return this.http.patch<ApiPayment>(`${this.baseUrl}/${id}/status`, {});
  }
}
